/* eslint-disable */
/* tslint:disable */

/** getHublerNetworkProfiles
 * method: get
 * summary: Get the hubler related network profiles
 */

import type {
  GetHublerNetworkProfilesResponseDto,
  ApiResponseDto,
} from './../api-types'

export const path = `/bff-worker/hubler-network-profiles`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/hubler-network-profiles`

export type GetHublerNetworkProfilesSuccess =
  GetHublerNetworkProfilesResponseDto
export type GetHublerNetworkProfilesError = ApiResponseDto
